import {
    monthsProduct,
    validationDefault,
    validationDefaultNew,
    defaultYearReport,
    maxModeloVehiculo,
} from '../../components/utilities/rulesUtilities';

import genericOptions from '../defaultConfigRole/genericOptions';
import genericColumnsCalculator from '../defaultConfigRole/genericColumnsCalculator';
import { randomFloat } from '../../components/utilities/functions/General';
import { requestsListStatus } from './RequestsListStatus';
import { objGenericUrl } from '../defaultConfigRole/genericUrls';

import { PROPERTIES, URL } from '../../constants/constantValues';

const Rules = {
    role_32fe968d846d4544ab7da197760f16f2: {
        home: 'credits',
        requestsListStatus,
        views: {
            create: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: ['processRequestCredit', 'listRequestCredit'],
                components: [
                    { name: 'Documentos', component: ['DocumentsCredit'] },
                    {
                        name: 'Solicitante',
                        component: ['InformationClient', 'FilterAutomatics'],
                    },
                    {
                        name: 'Consultas',
                        component: ['AutomaticFilters', 'ExceptionClient'],
                    },
                    {
                        name: 'Vínculos',
                        component: ['ContactLinks'],
                    },
                    // {
                    //     name: 'Registro de Visitas',
                    //     component: ['RecordVisitCredit'],
                    // },
                    {
                        name: 'Contacto',
                        component: ['ContactsClient'],
                    },
                    {
                        name: 'Inf. solicitud',
                        component: ['InformationCredit', 'CalculatorCredit'],
                    },
                    {
                        name: 'Inf. negocio',
                        component: ['BusinessInformationCredit'],
                    },
                    {
                        name: 'Codeudores',
                        component: ['CodebtorConyugeCredit'],
                    },
                    { name: 'Referencias', component: ['ReferencesCredit'] },
                    {
                        name: 'Análisis microempresa',
                        component: ['AnalisisCredit'],
                    },
                    { name: 'Ppi', component: ['PpiCredit'] },
                ],
                actionStatus: [
                    'rechazar',
                    'desistir',
                    'devolver',
                    'resumen',
                    'anotaciones',
                    'retornar',
                    'modalHallazgos',
                ],
                actionStatusAll: ['resumen', 'anotaciones'],
                causalType: 7,
                groupUser: 4,
            },
            consult: {
                permisions: [
                    'consultClientList',
                    'ConsultClientEdit',
                    'InformationCredit:edit',
                ],
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    { name: 'Contacto', component: ['ContactsClient'] },
                    { name: 'Documentos', component: ['DocumentsClient'] },
                    {
                        name: 'Solicitudes cliente',
                        component: ['RequestsClient'],
                    },
                    { name: 'Crédito', component: ['GygClient'] },
                ],
                noShowFieldsConsult: false,
            },
            profile: {
                fields: [
                    {
                        name: 'identification_number',
                        label: 'Número de identificación',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                    },
                    {
                        name: 'first_name',
                        label: 'Nombres',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'nombres'
                        ),
                    },
                    {
                        name: 'last_name',
                        label: 'Apellidos',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'apellidos'
                        ),
                    },
                    {
                        name: 'phone_number',
                        label: 'Número telefónico',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                ],
            },
        },
        components: {
            informationClient: {
                permisions: [
                    'informationClient:list',
                    'informationClient:edit',
                ],

                // automaticFilters: true,
                fields: [
                    {
                        name: 'tipo_identificacion',
                        testid: 'ClientTypeIdInput',
                        label: 'Tipo identificación',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo de identificación'
                        ),
                    },
                    {
                        label: 'Número de identificación',
                        name: 'numero_identificacion',
                        testid: 'ClientIdInput',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],

                            'número de identificación'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        testid: 'ClientFirstNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],

                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        testid: 'ClientSecondNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        testid: 'ClientLastFirsNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],

                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        testid: 'ClientSecondFirsNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'genero',
                        testid: 'ClientGenderInput',
                        label: 'Género',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                        validation: validationDefault(['required'], 'genero'),
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        testid: 'ClientDocumentPlaceInput',
                        label: 'Lugar expedición documento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de expedición documento'
                        ),
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        testid: 'ClientDocumentDateInput',
                        label: 'Fecha expedición documento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de expedición del documento'
                        ),
                    },
                    {
                        name: 'lugar_nacimiento',
                        testid: 'ClientBirthPlaceInput',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de nacimiento'
                        ),
                    },
                    {
                        name: 'fecha_nacimiento',
                        testid: 'ClientBirthDateInput',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                    },
                    {
                        name: 'grupo_social',
                        testid: 'ClientSocialGroupInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.grupo_etnico,
                    },
                    {
                        name: 'peps',
                        testid: 'ClientPepsInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.direccion_principal,
                        validation: validationDefault(['required'], 'Peps'),
                    },
                ],

                informacion_Trabajo: [
                    {
                        name: 'trabajo_nombre',
                        testid: 'ClientSocialGroupInput',
                        label: 'Empresa',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.JOB_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.JOB_NAME.minLength,
                                },
                            ],

                            'empresa'
                        ),
                    },
                    {
                        name: 'trabajo_ciudad',
                        testid: 'ClientJobCityInput',
                        label: 'Ciudad de trabajo',
                        disabled: true,
                        type: 'autocomplete',
                        col: 6,
                        options: [],
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'trabajo_direccion',
                        testid: 'ClientJobAddressInput',
                        label: 'Dirección del trabajo',
                        disabled: true,
                        type: 'addressComplement',
                        staticCol: 12,
                    },
                    {
                        name: 'referencia_ubicacion',
                        testid: 'ContactUbicationInput',
                        label: 'Referencia ubicación',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'trabajo_antiguedad',
                        testid: 'ClientJobAntiquityInput',
                        label: 'Antigüedad (meses)',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],

                            'antigüedad (meses)'
                        ),
                    },
                    {
                        name: 'trabajo_telefono',
                        testid: 'ClientJobPhoneInput',
                        label: 'Teléfono de la empresa',
                        disabled: true,
                        type: 'phone',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],

                            'teléfono de la empresa'
                        ),
                    },
                    {
                        name: 'empresa_salario',
                        testid: 'ClientCompanySalaryInput',
                        label: 'Ingresos',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.INCOME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.INCOME.minLength,
                                },
                            ],

                            'ingresos'
                        ),
                    },
                    {
                        name: 'negocio_actividad',
                        testid: 'ClientBusinessActivityInput',
                        label: 'Actividad económica',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                    },
                ],
            },
            socioeconomicClient: {
                permisions: [
                    'socioeconomicClient:list',
                    'socioeconomicClient:edit',
                ],

                fields: [
                    {
                        name: 'estado_civil',
                        testid: 'ClientCivilStatusInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.estado_civil,
                        validation: validationDefault(
                            ['required'],
                            'estado civil'
                        ),
                    },
                    {
                        name: 'tipo_vivienda',
                        testid: 'ClientHousingTypeInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_vivienda,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'tipo vivienda'
                        ),
                    },
                    {
                        name: 'estrato',
                        testid: 'ClientStratumInput',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.STRATUM.required,
                                },
                                { type: 'max', value: PROPERTIES.STRATUM.max },
                                { type: 'min', value: PROPERTIES.STRATUM.min },
                            ],

                            'estrato'
                        ),
                    },

                    {
                        label: 'Antigüedad residencia (meses)',
                        name: 'antiguedad_residencia',
                        testid: 'ClientResidenceAntiquityInput',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],

                            'antigüedad residencia'
                        ),
                    },
                    {
                        name: 'tamano_hogar',
                        testid: 'ClientHouseholdSizeInput',
                        label: 'Integrantes del hogar',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.HOUSEHOLD_MEMBERS.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.HOUSEHOLD_MEMBERS.min,
                                },
                            ],

                            'Integrantes del hogar'
                        ),
                    },
                    {
                        name: 'personas_a_cargo',
                        testid: 'ClientPeopleInChargeInput',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.PEOPLE_IN_CHARGE.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.PEOPLE_IN_CHARGE.min,
                                },
                            ],

                            'personas a cargo'
                        ),
                    },
                    {
                        name: 'numero_hijos',
                        testid: 'ClientChildrenNumberInput',
                        label: 'Número hijos',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.NUMBER_OF_CHILDREN.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.NUMBER_OF_CHILDREN.min,
                                },
                            ],

                            'número de hijos'
                        ),
                    },
                    {
                        name: 'escolaridad',
                        testid: 'ClientEducationInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.escolaridad,
                        validation: validationDefault(
                            ['required'],
                            'escolaridad'
                        ),
                    },
                    {
                        name: 'naturaleza',
                        disabled: true,
                        type: 'hidden',
                        col: 3,
                        isMulti: false,
                    },
                    {
                        name: 'ciiu',
                        testid: 'ClientEconomicActivityInput',
                        label: 'Actividad económica',
                        disabled: false,
                        type: 'autocomplete',
                        col: 6,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                        validation: validationDefault(
                            ['required'],
                            'Actividad económica'
                        ),
                    },
                    {
                        name: 'descripcion_actividad_economica',
                        testid: 'ClientEconomicActivityDescriptionInput',
                        label: 'Descripción actividad económica',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .maxLength,
                                },
                            ],

                            'descripción actividad económica'
                        ),
                    },
                ],
            },
            contactsClient: {
                permisions: [
                    'contactsClient:list',
                    'contactsClient:edit',
                    'contactsClient:editButton',
                    'contactsClient:deleteButton',
                    'contactsClient:editButtonConsult',
                ],

                tittle: 'solicitante',
                fields: [
                    {
                        name: 'ciudad_contacto',
                        testid: 'ContactCityInput',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_contacto',
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'ciudad de contacto'
                        ),
                    },
                    {
                        name: 'barrio_contacto',
                        testid: 'ContactNeighborhoodInput',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_contacto',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio de contacto'
                        ),
                    },
                    {
                        name: 'direccion',
                        testid: 'ContactAddressInput',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ADDRESS.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ADDRESS.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ADDRESS.minLength,
                                },
                            ],

                            'dirección'
                        ),
                    },
                    {
                        name: 'referencia_ubicacion',
                        testid: 'ContactUbicationInput',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'telefono',
                        testid: 'ContactPhoneInput',
                        label: 'Teléfono',
                        disabled: false,
                        type: 'phone',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],

                            'teléfono'
                        ),
                    },
                    {
                        name: 'celular',
                        testid: 'ContactCellphoneInput',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],

                            'celular'
                        ),
                    },
                    {
                        name: 'correo_electronico',
                        testid: 'ContactEmailInput',
                        label: 'Correo electrónico',
                        disabled: false,
                        type: 'email',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.EMAIL.regExp,
                                    mesagge:
                                        'El correo electrónico ingresado no es válido',
                                },
                                {
                                    type: 'required',
                                    value: true,
                                },
                            ],

                            'correo electrónico'
                        ),
                    },
                    {
                        name: 'principal',
                        testid: 'ContactPrincipalInput',
                        label: 'Dirección principal',
                        disabled: false,
                        type: 'select',
                        options: genericOptions.direccion_principal,
                        defaultValue: [],
                        col: 6,
                        showTable: true,
                    },
                ],

                defaultValues: {
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    latitud: '11111324',
                    longitud: '38947239',
                    telefono: '',
                    celular: '',
                    correo_electronico: 'test@finamiga.co',
                    referencia_ubicacion: 'cerca a... diagonal a...',
                    tipo_ubicacion: 1,
                    departamento: 5,
                    ciudad_contacto: 1205,
                },
            },
            informationCredit: {
                permisions: [
                    'informationCredit:list',
                    'informationCredit:edit',
                ],

                fields: [
                    {
                        name: 'subproducto',
                        testid: 'SubproductInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                    },

                    {
                        name: 'oficina',
                        testid: 'OfficeInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'ejecutivo',
                        url: URL.OFICINAS.value,
                        validation: validationDefault(['required'], 'oficina'),
                    },
                    {
                        name: 'ejecutivo',
                        testid: 'ExecutiveInput',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        dependency: 'oficinas',
                        url: URL.EJECUTIVOS.value,
                        notSearchGlobals: true,
                        validation: validationDefault(
                            ['required'],
                            'ejecutivo'
                        ),
                    },
                    {
                        name: 'origen',
                        testid: 'originInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        url: URL.ORIGEN.value,
                        validation: validationDefault(['required'], 'origen'),
                    },
                    {
                        name: 'medio',
                        testid: 'mediumInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        url: URL.MEDIO.value,
                        validation: validationDefault(['required'], 'medio'),
                    },
                    {
                        name: 'tipo_credito',
                        testid: 'CreditTypeInput',
                        label: 'Tipo crédito',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_credito,
                        validation: validationDefault(
                            ['required'],
                            'tipo crédito'
                        ),
                    },
                    {
                        name: 'seguro_voluntario',
                        testid: 'VoluntaryInsureInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                        validation: validationDefault(
                            ['required'],
                            'seguro voluntario'
                        ),
                    },
                    {
                        name: 'seguro_protegidos',
                        testid: 'ProtectedInsuranceInput',
                        label: 'Seguro PROTEGI2',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        clear: true,
                        url: URL.SEGURO_FAMILIA.value,
                        dependency: 'subproducto',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 3,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                    // INFORMACION DEL FONDO NACIONAL DE GARANTIAS
                    {
                        name: 'tipo_garantia',
                        testid: 'GuaranteeTypeInput',
                        label: 'Garantía',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.garantia,
                    },
                ],

                fieldsFng: [
                    {
                        name: 'fng_producto',
                        testid: 'FngProductInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        url: URL.FNG_PRODUCTO.value,
                        parentDependency: true,
                        childrenDependency: 'fng_porcentaje',
                        validation: validationDefault(
                            ['required'],
                            'fng producto'
                        ),
                    },
                    {
                        name: 'fng_porcentaje',
                        testid: 'FngPercentageInput',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        dependency: 'fng_producto',
                        url: URL.FNG_PORCENTAJE.value, //?fng_producto=4',
                        validation: validationDefault(
                            ['required'],
                            'fng porcentaje'
                        ),
                    },
                ],

                fieldsDynamic: [],
                defaultValues: {
                    oficina: 9,
                    producto: 17,
                    origen: 1,
                    medio: 1,
                    tipo_credito: 1,
                    monto_solicitado: 5000000,
                    plazo_solicitado: 2,
                    cuota_inicial_solicitada: 1500000,
                    asesor: 'asesor test',
                    telefono_asesor: '123456798',
                    concesionario: 'concesionario test',
                    marca: 'Bajaj',
                    linea: 'Pulsar',
                    valor: 8000000,
                    soat: 480000,
                    impuestos: 120000,
                    matricula: 200000,
                    nombre_concesionario: 'concesionario test!',
                    tipo_motocicleta: 'motocicleta',
                },
            },
            productCredit: {
                permisions: ['productCredit:list', 'productCredit:edit'],
                fields: [],
                filedsConditional: {
                    p2: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'ProductAllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'ProductBrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'ProductLineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'ProductTypeInput',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ProductValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'ProductSoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'ProductTaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'ProductRegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'ProductDownPaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'ProductRequestedAmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'ProductRequestedTermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'ProductAllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'ProductAgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p3: [
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            testid: 'ProductDestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'ProductAllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],

                    p8: [
                        // Prestamiga Preferencial
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],

                    p10: [
                        // Prestamiga Renovacion
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],

                    p18: [
                        // Prestamiga Reactivacion
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],

                    p6: [
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault([''], 'ciudad'),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                [''],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p12: [
                        // Cultiva renovacion
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault([''], 'ciudad'),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                [''],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p14: [
                        // Cultiva preferencial
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault([''], 'ciudad'),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                [''],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p17: [
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',

                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p40: [
                        // Vehiculos usados
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: maxModeloVehiculo(),
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'valor_fasecolda',
                            testid: 'FasecoldaValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p41: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },

                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p42: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p43: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p47: [
                        // Vehiculos renovacion
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p113: [
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p114: [
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },

                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            testid: 'MachineryValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p115: [
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p117: [
                        // CARGA_ESPECIALES_2.0
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            testid: 'MachineryValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p118: [
                        // carga pasajeros 2.0
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p119: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p120: [
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p131: [
                        // MOTO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'ProductAllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'ProductBrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'ProductLineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'ProductTypeInput',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ProductValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'ProductSoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'ProductTaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'ProductRegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'ProductDownPaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'ProductRequestedAmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'ProductRequestedTermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'ProductAllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'ProductAgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p132: [
                        // PROGRESA RECONSTRUYE
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            testid: 'ProductDestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'ProductAllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p133: [
                        // CAMPO RECONSTRUYE
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault([''], 'ciudad'),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                [''],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p134: [
                        // CARGA RECONSTRUYE
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',

                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p135: [
                        // MOTOCARRO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p136: [
                        // PROGRESA COMPROMISO VALLE RECONSTRUYE
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p137: [
                        // CARGA 2.0 RECONSTRUYE
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p138: [
                        // CARGA ESPECIALES RECONSTRUYE
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },

                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            testid: 'MachineryValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p139: [
                        // CARGA PASAJEROS RECONSTRUYE
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p130: [
                        // MOTO COMPROMISO VALLE RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                },
            },
            documentsCredit: {
                permisions: ['documentsCredit:list', 'documentsCredit:edit'],
                fields: [
                    {
                        name: 'solicitud_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/solicitudes/tipo_documentos/?roles=4&productos={0}&is_active=true',
                        reduxParams: ['credit.subproducto.producto'],
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                        testid: 'DocumentTypeInput',
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                        testid: 'DocumentFileInput',
                    },
                ],
            },
            documentsClient: {
                permisions: ['documentsClient:list', 'documentsClient:edit'],
                fields: [
                    {
                        name: 'persona_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/personas/tipo_documentos/?roles=4',
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                    },
                ],
            },
            documentsDisbursement: {
                permisions: ['documentsDisbursement:list'],
                fields: [
                    {
                        name: 'solicitud_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/solicitudes/tipo_documentos/?roles=4&productos={0}&is_active=true',
                        reduxParams: ['credit.producto'],
                        shouldSendRequestConstantly: true,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                    },
                ],
            },
            observationCredit: {
                permisions: [
                    'observationCredit:list',
                    'observationCredit:edit',
                ],

                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 10,
                        showTable: true,
                        staticCol: 10,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                    {
                        name: 'is_alerta',
                        label: 'Alerta',
                        type: 'switch',
                        typeColumn: 2,
                        staticCol: 2,
                        col: 2,
                    },
                ],
            },
            calculatorCredit: {
                permisions: [
                    'calculatorCredit:list',
                    'calculatorCredit:edit',
                    'calculatorCredit:simulator',
                ],

                summaryCredit: genericColumnsCalculator.summaryCredit,
                monthlyValues: genericColumnsCalculator.monthlyValues,
                defaultValues: {},
                fields: [
                    {
                        name: 'subproducto',
                        testid: 'SubproductInput',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                    },
                    {
                        name: 'seguro_voluntario',
                        testid: 'VoluntaryInsureInput',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                        validation: validationDefault(
                            ['required'],
                            'seguro voluntario'
                        ),
                    },
                    {
                        name: 'seguro_protegidos',
                        testid: 'ProtectedInsuranceInput',
                        label: 'Seguro PROTEGI2',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        clear: true,
                        url: URL.SEGURO_FAMILIA.value,
                        dependency: 'subproducto',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 4,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
            },
            ReferencesCredit: {
                fields: [
                    {
                        name: 'persona_referenciada',
                        disabled: false,
                        type: 'select',
                        col: 12,
                        shouldSendRequestConstantly: true,
                        url: objGenericUrl.personaSolicitudReferecias,
                        reduxParams: ['client.id', 'credit.id'],
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'persona referenciada'
                        ),
                        testid: 'ReferencePersonInput',
                    },
                    {
                        name: 'celular',
                        disabled: false,
                        type: 'celular',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],

                            'celular'
                        ),
                        testid: 'ReferenceCellphoneInput',
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],

                            'primer nombre'
                        ),
                        testid: 'ReferenceFirstNameInput',
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'primer nombre'
                        ),
                        testid: 'ReferenceSecondNameInput',
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],

                            'primer apellido'
                        ),
                        testid: 'ReferenceLastNameInput',
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo apellido'
                        ),
                        testid: 'ReferenceSecondLastNameInput',
                    },
                    {
                        name: 'estado_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.estado_referencia,
                        validation: validationDefault(
                            ['required'],
                            'estado referencia'
                        ),
                        testid: 'ReferenceStatusInput',
                    },
                    {
                        name: 'tipo_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        // options: genericOptions.tipo_referencia,
                        parentDependency: true,
                        childrenDependency: 'barrio_referencia',
                        url: '/globals/tipo_referencia/',
                        notSearchGlobals: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo referencia'
                        ),
                        testid: 'ReferenceTypeInput',
                    },
                    {
                        name: 'parentesco_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        dependency: 'tipo_referencia',
                        url: '/globals/parentesco_referencia/',
                        // options: genericOptions.tipo_parentesco,
                        validation: validationDefault(
                            ['required'],
                            'parentesco'
                        ),
                        testid: 'ReferenceRelationshipInput',
                    },
                    {
                        name: 'ciudad',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_referencia',
                        url: URL.CIUDADES.value,
                        validation: validationDefault(['required'], 'ciudad'),
                        testid: 'ReferenceCityInput',
                    },
                    {
                        name: 'barrio_referencia',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio referencia'
                        ),
                        testid: 'ReferenceNeighborhoodInput',
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'dirección'
                        ),
                        showTable: true,
                        testid: 'ReferenceAddressInput',
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.minLength,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.maxLength,
                                },
                            ],

                            'referencia ubicación'
                        ),
                        testid: 'ReferenceUbicationInput',
                    },
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.OBSERVATION.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.OBSERVATION.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.OBSERVATION.minLength,
                                },
                            ],

                            'observación'
                        ),
                        testid: 'ReferenceObservationInput',
                    },
                ],

                fieldsKnowsHim: [
                    {
                        name: 'antiguedad',
                        label: '¿Hace cuanto tiempo lo conoce?',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: genericOptions.conoce_cliente,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],

                            'antigüedad'
                        ),
                        testid: 'ReferenceAntiquityInput',
                    },
                    {
                        name: 'recomendaria',
                        label: 'Recomendaría',
                        disabled: false,
                        type: 'switch',
                        col: 6,
                        typeColumn: 2,
                        testid: 'ReferenceRecommendInput',
                    },
                    {
                        name: 'actividad_economica',
                        label: 'Actividad económica',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .minLength,
                                },
                            ],

                            'actividad económica'
                        ),
                        testid: 'ReferenceEconomicActivityInput',
                    },
                    {
                        name: 'antiguedad_actividad_economica',
                        label: 'Antigüedad actividad económica (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],

                            'antigüedad actividad económica'
                        ),
                        testid: 'ReferenceEconomicActivityAntiquityInput',
                    },
                    {
                        name: 'actividad_economica_adicional',
                        label: 'Actividad económica adicional',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .minLength,
                                },
                            ],

                            'actividad económica adicional'
                        ),
                        testid: 'ReferenceAdditionalEconomicActivityInput',
                    },
                    {
                        name: 'antiguedad_actividad_economica_adicional',
                        label: 'Antigüedad actividad económica adicional (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],

                            'antigüedad actividad económica adicional'
                        ),
                        testid: 'ReferenceAdditionalEconomicActivityAntiquityInput',
                    },
                ],

                defaultValues: {
                    primer_nombre: 'pruebas1',
                    primer_apellido: 'sistemas',
                    segundo_apellido: 'sistemas 2',
                    celular: '3249872938',
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    estado_referencia: 1,
                    parentesco: 0,
                    tipo_referencia: 0,
                    conoce: true,
                    recomendaria: false,
                    actividad_economica: 'venta de pollos',
                    observacion: 'ninguna',
                    antiguedad: 2,
                },
            },
            analysisCredit: {
                permisions: ['analysisCredit:list', 'analysisCredit:edit'],
                fields: [
                    {
                        name: 'LIQUIDEZ DEL NEGOCIO',
                        desc: '',
                        fields: [
                            {
                                name: 'ventas',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'ventas'
                                ),
                            },
                            {
                                name: 'costo_venta',
                                label: 'Costo venta (%)',
                                disabled: false,
                                type: 'percentage',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.COST_OF_SALE
                                                .required,
                                        },
                                        {
                                            type: 'maxValueString',
                                            value: PROPERTIES.COST_OF_SALE
                                                .maxValueString,
                                        },
                                    ],

                                    'costo de ventas'
                                ),
                            },
                            {
                                name: 'total_gastos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total gastos'
                                ),
                            },
                            {
                                name: 'pagos_deudas',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'pago deudas'
                                ),
                            },
                            {
                                name: 'utilidad_neta',
                                disabled: true,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'utilidad neta'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'LIQUIDEZ FAMILIAR',
                        desc: '',
                        fields: [
                            {
                                name: 'otros_ingresos',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'otros ingresos'
                                ),
                            },
                            {
                                name: 'total_gastos_familiar',
                                label: 'Total gastos familiares',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'total gastos'
                                ),
                            },
                            {
                                name: 'liquidez_total',
                                disabled: true,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'liquidez total'
                                ),
                            },
                            {
                                name: 'capacidad_pago',
                                disabled: true,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'capacidad de pago'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'BALANCE GENERAL DE LA MICROEMPRESA',
                        desc: '',
                        fields: [
                            {
                                name: 'activos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total activos'
                                ),
                            },
                            {
                                name: 'pasivos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total pasivos'
                                ),
                            },
                            {
                                name: 'patrimonio',
                                disabled: true,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total patrimonio'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'INDICADORES FINANCIEROS',
                        desc: '',
                        fields: [
                            {
                                name: 'capacidad_pago_porcentaje',
                                label: 'Capacidad pago porcentaje (%)',
                                disabled: true,
                                type: 'percentage',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'capacidad de pago'
                                ),
                            },
                            {
                                name: 'capital_trabajo',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'capital de trabajo'
                                ),
                            },
                            {
                                name: 'endeudamiento_actual',
                                label: 'Endeudamiento actual (%)',
                                disabled: true,
                                type: 'percentage',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'endeudamiento actual'
                                ),
                            },
                            {
                                name: 'endeudamiento_futuro',
                                label: 'Endeudamiento futuro (%)',
                                disabled: true,
                                type: 'percentage',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'endeudamiento futuro'
                                ),
                            },
                            {
                                name: 'rotacion',
                                label: 'Rotación de inventario (Días)',
                                disabled: false,
                                type: 'integer',
                                col: 4,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.INVENTORY_ROTATE
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.INVENTORY_ROTATE
                                                .maxLength,
                                        },
                                    ],

                                    'rotación de inventario'
                                ),
                            },
                            {
                                name: 'liquidez_financiera',
                                label: 'Liquidez razón corriente',
                                disabled: false,
                                type: 'integer',
                                col: 4,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES
                                                .FINANCIAL_LIQUIDITY.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .FINANCIAL_LIQUIDITY.maxLength,
                                        },
                                    ],

                                    'liquidez financiera'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'PROPUESTA',
                        desc: '',
                        fields: [
                            {
                                name: 'propuesta_economica',
                                label: 'Propuesta económica',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'propuesta económica ejecutivo'
                                ),
                            },
                            {
                                name: 'plazo_propuesta',
                                label: 'Plazo propuesto',
                                disabled: false,
                                type: 'select',
                                options: monthsProduct(17),
                                col: 6,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'plazo propuesto'
                                ),
                            },
                            {
                                name: 'cuota_inicial_propuesta',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'cuota inicial'
                                ),
                            },
                            {
                                name: 'cuota_mensual_propuesta',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'cuota mensual'
                                ),
                            },
                        ],
                    },
                ],

                defaultValues: {
                    ventas: Math.floor(randomFloat(0, 1) * 1000000),
                    costo_venta: Math.floor(randomFloat(0, 1) * 10),
                    total_gastos: Math.floor(randomFloat(0, 1) * 10000),
                    pagos_deudas: 0,
                    utilidad_neta: 0,
                    otros_ingresos: 0,
                    total_gastos_familiar: Math.floor(
                        randomFloat(0, 1) * 10000
                    ),
                    liquidez_total: 0,
                    capacidad_pago: 0,
                    activos: Math.floor(randomFloat(0, 1) * 10000),
                    pasivos: Math.floor(randomFloat(0, 1) * 10000),
                    patrimonio: 0,
                    capacidad_pago_porcentaje: 0,
                    capital_trabajo: Math.floor(randomFloat(0, 1) * 10000),
                    endeudamiento_actual: 0,
                    endeudamiento_futuro: 0,
                    rotacion: Math.floor(randomFloat(0, 1) * 10000),
                    liquidez_financiera: 5,
                    propuesta_economica: Math.floor(
                        randomFloat(0, 1) * 1000000
                    ),
                    plazo_propuesta: Math.floor(randomFloat(0, 1) * 10),
                    cuota_inicial_propuesta: 0,
                    cuota_mensual_propuesta: Math.floor(
                        randomFloat(0, 1) * 10000
                    ),
                },
            },
            Ppi: {
                permission: ['Ppi:list', 'Ppi:edit'],
                fields: [
                    {
                        id: '1',
                        question: '¿Cuántos miembros tiene el hogar?',
                        options: [
                            {
                                response: 'A. 2 o menos',
                                points: 20,
                                idQuestions: 'ppi_1_1',
                            },
                            {
                                response: 'B. 3 a 4',
                                points: 10,
                                idQuestions: 'ppi_1_2',
                            },
                            {
                                response: 'C. 5 a 6',
                                points: 3,
                                idQuestions: 'ppi_1_3',
                            },
                            {
                                response: 'D. 7 o más',
                                points: 0,
                                idQuestions: 'ppi_1_4',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_1',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 1'
                        ),
                    },
                    {
                        id: '2',
                        question: '¿Todos los niños entre los 6 y 12?',
                        options: [
                            {
                                response:
                                    'A. Al menos un niño entre 6 y 12 años no asiste',
                                points: 0,
                                idQuestions: 'ppi_2_1',
                            },
                            {
                                response: 'B. No hay niños entre 6 y 12 años',
                                points: 7,
                                idQuestions: 'ppi_2_2',
                            },
                            {
                                response:
                                    'C. Todos los niños entre 6 y 12 años asisten',
                                points: 1,
                                idQuestions: 'ppi_2_3',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_2',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 2'
                        ),
                    },
                    {
                        id: '3',
                        question:
                            '¿Algún miembro de este hogar alcanzó un nivel educativo superior o universitario?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 6,
                                idQuestions: 'ppi_3_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_3_2',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_3',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 3'
                        ),
                    },
                    {
                        id: '4',
                        question:
                            '¿Algún miembro de este hogar tiene un trabajo con un contrato escrito?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 15,
                                idQuestions: 'ppi_4_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_4_2',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_4',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 4'
                        ),
                    },
                    {
                        id: '5',
                        question:
                            '¿Algún miembro de este hogar es un obrero o empleado de empresa particular/privada?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 9,
                                idQuestions: 'ppi_5_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_5_2',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_5',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 5'
                        ),
                    },
                    {
                        id: '6',
                        question:
                            '¿Algún miembro de este hogar es un patrón o empleador?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 15,
                                idQuestions: 'ppi_6_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_6_2',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_6',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 6'
                        ),
                    },
                    {
                        id: '7',
                        question:
                            '¿Este hogar tiene una máquina lavadora de ropa?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 6,
                                idQuestions: 'ppi_7_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_7_2',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_7',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 7'
                        ),
                    },
                    {
                        id: '8',
                        question: '¿Este hogar tiene un horno microondas?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 8,
                                idQuestions: 'ppi_8_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_8_2',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_8',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 8'
                        ),
                    },
                    {
                        id: '9',
                        question: '¿Este hogar tiene un carro particular?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 5,
                                idQuestions: 'ppi_9_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_9_2',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_9',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 9'
                        ),
                    },
                    {
                        id: '10',
                        question:
                            '¿Cuál es el material predominante de los pisos de la vivienda?',
                        options: [
                            {
                                response:
                                    'A. Tierra, arena, madera burda, tabla, tablón, otro vegetal',
                                points: 0,
                                idQuestions: 'ppi_10_1',
                            },
                            {
                                response: 'B. Cemento, gravilla',
                                points: 2,
                                idQuestions: 'ppi_10_2',
                            },
                            {
                                response:
                                    'C. Baldosín, ladrillo, vinisol, otros materiales sintéticos',
                                points: 9,
                                idQuestions: 'ppi_10_3',
                            },
                            {
                                response:
                                    'D. Mármol, madera pulida, alfombra o tapete de pared a pared',
                                points: 6,
                                idQuestions: 'ppi_10_4',
                            },
                        ],

                        type: 'radio',
                        name: 'ppi_10',
                        disabled: false,
                        validation: validationDefault(
                            ['required'],
                            'Pregunta 10'
                        ),
                    },
                ],
            },
            BusinessInformationCredit: {
                permisions: [
                    'businessInformationCredit:list',
                    'businessInformationCredit:edit',
                ],

                fields: [
                    {
                        name: 'nombre',
                        testid: 'BusinessNameInput',
                        label: 'Nombre del negocio',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.JOB_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.JOB_NAME.minLength,
                                },
                            ],

                            'nombre del negocio'
                        ),
                    },
                    {
                        name: 'tipo_negocio',
                        testid: 'BusineTypeInput',
                        label: 'Tipo de negocio',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'Tipo de negocio'
                        ),
                    },
                    {
                        name: 'antiguedad',
                        testid: 'BusinessAntiquityInput',
                        label: 'Antigüedad de negocio (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],

                            'antigüedad de negocio (meses)'
                        ),
                    },
                    {
                        name: 'antiguedad_local',
                        testid: 'BusinessLocalAntiquityInput',
                        label: 'Antigüedad de negocio en local (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],

                            'antigüedad de negocio en local'
                        ),
                    },
                    {
                        name: 'empleados_permanentes',
                        testid: 'BusinessPermanentEmployeesInput',
                        label: 'Empleados permanentes',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.PERMANENT_EMPLOYES
                                        .required,
                                },
                                {
                                    type: 'max',
                                    value: PROPERTIES.PERMANENT_EMPLOYES.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.PERMANENT_EMPLOYES.min,
                                },
                            ],

                            'empleados permanentes del negocio'
                        ),
                    },
                    {
                        name: 'empleados_temporales',
                        testid: 'BusinessTemporaryEmployeesInput',
                        label: 'Empleados temporales',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.TEMPORARY_EMPLOYES
                                        .required,
                                },
                                {
                                    type: 'max',
                                    value: PROPERTIES.TEMPORARY_EMPLOYES.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.TEMPORARY_EMPLOYES.min,
                                },
                            ],

                            'empleados temporales del negocio'
                        ),
                    },
                    {
                        name: 'telefono',
                        testid: 'ContactPhoneInput',
                        label: 'Teléfono del negocio',
                        disabled: false,
                        type: 'phone',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],

                            'teléfono del negocio'
                        ),
                    },
                    {
                        name: 'celular',
                        testid: 'ContactCellphoneInput',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],

                            'celular'
                        ),
                    },
                    {
                        name: 'sector_economico',
                        testid: 'BusinessEconomicSectorInput',
                        label: 'Sector económico del negocio',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.sector_economico,
                        validation: validationDefault(
                            ['required'],
                            'sector económico del negocio'
                        ),
                    },
                    {
                        name: 'negocio_ciiu',
                        testid: 'BusinessActivityInput',
                        label: 'Actividad del negocio',
                        disabled: false,
                        type: 'autocomplete',
                        col: 6,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                        validation: validationDefault(
                            ['required'],
                            'actividad del negocio'
                        ),
                    },
                    {
                        name: 'descripcion_actividad',
                        testid: 'BusinessDescInput',
                        label: 'Descripción de la actividad del negocio',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .maxLength,
                                },
                            ],

                            'descripción de la actividad del negocio'
                        ),
                    },
                    {
                        name: 'ciudad_negocio',
                        testid: 'BusinessCityInput',
                        label: 'Ciudad del negocio',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_negocio',
                        url: URL.CIUDADES_POR_DEPARTAMENTO.value,
                        reduxParams: ['globals.departamentos_regional'],
                        searchSecondParam: true,
                        validation: validationDefault(
                            ['required'],
                            'ciudad del negocio'
                        ),
                    },
                    {
                        name: 'barrio_negocio',
                        testid: 'BusinessNeighborhoodInput',
                        label: 'Barrio del negocio',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_negocio',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio del negocio'
                        ),
                    },
                    {
                        name: 'direccion',
                        testid: 'ContactAddressInput',
                        label: 'Dirección del negocio',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'dirección del negocio'
                        ),
                    },
                    {
                        name: 'referencia_ubicacion',
                        testid: 'ContactUbicationInput',
                        label: 'Referencia para ubicación del negocio',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.minLength,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.maxLength,
                                },
                            ],

                            'referencia para ubicación del negocio'
                        ),
                    },
                    {
                        name: 'tipo_local',
                        testid: 'BusinessLocalTypeInput',
                        label: 'Tipo de local',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: genericOptions.tipo_local,
                        validation: validationDefault(
                            ['required'],
                            'tipo de local del negocio'
                        ),
                    },

                    {
                        name: 'rut',
                        testid: 'BusinessRutInput',
                        label: 'RUT',
                        disabled: false,
                        type: 'checkbox',
                        col: 1,
                        typeColumn: 3,
                    },
                    {
                        name: 'camara_comercio',
                        testid: 'BusinessCommerceChamberInput',
                        label: 'Cámara de comercio',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'registra_compras',
                        testid: 'BusinessPurchaseRegistryInput',
                        label: 'Registra compras',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'registra_ventas',
                        testid: 'BusinessSalesRegistryInput',
                        label: 'Registra ventas',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'eps',
                        testid: 'BusinessEpsInput',
                        label: 'EPS',
                        disabled: false,
                        type: 'checkbox',
                        col: 1,
                        typeColumn: 3,
                    },
                    {
                        name: 'sisben',
                        testid: 'BusinessSisbenInput',
                        label: 'SISBEN',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'responsable_iva',
                        testid: 'BusinessVatResponsibleInput',
                        label: 'Responsable de IVA',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                ],

                defaultValues: {
                    tipo_negocio: 'venta de papa',
                    nombre: 'papaMania',
                    antiguedad: 8,
                    antiguedad_local: 5,
                    descripcion_actividad: 'venta de papa',
                    telefono: '7230000',
                    celular: '3164907501',
                    direccion: 'calle  8norte  13a  45',
                    barrio: 'pruebas',
                    referencia_ubicacion: 'en la esquina cruza',
                    sector_economico: 0,
                    tipo_local: 0,
                    empleados_permanentes: 1,
                    empleados_temporales: 1,
                },
            },
            conyugeClient: {
                permisions: ['conyugeClient:list', 'conyugeClient:edit'],
                fields: [
                    {
                        name: 'Información básica',
                        desc: '',
                        fields: [
                            {
                                name: 'tipo_identificacion',
                                testid: 'ConyugeTypeIdInput',
                                label: 'Tipo identificación',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_de_documento,
                                validation: validationDefault(
                                    ['required'],
                                    'tipo identificación'
                                ),
                            },
                            {
                                name: 'numero_identificacion',
                                testid: 'ConyugeIdInput',
                                label: 'Número de identificación',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ID_NUMBER
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.ID_NUMBER
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.ID_NUMBER
                                                .minLength,
                                        },
                                    ],

                                    'número de identificación'
                                ),
                            },
                            {
                                name: 'primer_nombre',
                                testid: 'ConyugeFirstNameInput',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.FIRST_NAME
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.FIRST_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.FIRST_NAME
                                                .minLength,
                                        },
                                    ],

                                    'primer nombre'
                                ),
                            },
                            {
                                name: 'segundo_nombre',
                                testid: 'ConyugeSecondNameInput',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .minLength,
                                        },
                                    ],

                                    'segundo nombre'
                                ),
                            },
                            {
                                name: 'primer_apellido',
                                testid: 'ConyugeFirstSurnameInput',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .minLength,
                                        },
                                    ],

                                    'primer apellido'
                                ),
                            },
                            {
                                name: 'segundo_apellido',
                                testid: 'ConyugeSecondSurnameInput',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.SECOND_SURNAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .minLength,
                                        },
                                    ],

                                    'segundo apellido'
                                ),
                            },
                            {
                                name: 'genero',
                                testid: 'ConyugeGenderInput',
                                label: 'Género',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.genero,
                                validation: validationDefault(
                                    ['required'],
                                    'genero'
                                ),
                            },
                            {
                                name: 'lugar_nacimiento',
                                disabled: false,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'lugar de nacimiento'
                                ),
                            },
                            {
                                name: 'fecha_nacimiento',
                                disabled: false,
                                type: 'date',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'fecha de nacimiento'
                                ),
                            },
                            {
                                name: 'lugar_expedicion_documento',
                                label: 'Lugar expedición documento',
                                disabled: false,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'lugar de expedición documento'
                                ),
                            },
                            {
                                name: 'fecha_expedicion_documento',
                                label: 'Fecha expedición documento',
                                disabled: false,
                                type: 'date',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'fecha de expedición del documento'
                                ),
                            },
                            {
                                name: 'tipo_relacion',
                                label: 'Tipo relación',
                                disabled: true,
                                type: 'hidden',
                                col: 3,
                                value: 0,
                            },
                            {
                                name: 'estado_civil',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'Información de contacto',
                        desc: '',
                        fields: [
                            {
                                name: 'ciudad_contacto',
                                label: 'Ciudad',
                                disabled: false,
                                type: 'autocomplete-dependency',
                                col: 6,
                                showTable: true,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'barrio_contacto',
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'ciudad de contacto'
                                ),
                            },
                            {
                                name: 'barrio_contacto',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                showTable: true,
                                dependency: 'ciudad_contacto',
                                options: [],
                                url: URL.BARRIOS.value,
                                validation: validationDefault(
                                    ['required'],
                                    'barrio de contacto'
                                ),
                            },
                            {
                                name: 'direccion',
                                label: 'Dirección',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ADDRESS.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.ADDRESS.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.ADDRESS.minLength,
                                        },
                                    ],

                                    'dirección'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                            },
                            {
                                name: 'telefono',
                                label: 'Teléfono',
                                disabled: false,
                                type: 'phone',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono'
                                ),
                            },
                            {
                                name: 'celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],

                                    'celular'
                                ),
                            },
                            {
                                name: 'correo_electronico',
                                label: 'Correo electrónico',
                                disabled: false,
                                type: 'email',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.EMAIL.regExp,
                                            mesagge:
                                                'El correo electrónico ingresado no es válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.EMAIL.required,
                                        },
                                    ],

                                    'correo electrónico'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'Información del trabajo',
                        desc: '',
                        fields: [
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],

                                    'empresa'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],

                                    'antigüedad (meses)'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono del trabajo',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Ingresos mensuales',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.INCOME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.INCOME.minLength,
                                        },
                                    ],

                                    'ingresos'
                                ),
                            },
                            {
                                name: 'otros_ingresos',
                                label: 'Otros ingresos',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.INCOME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.INCOME.minLength,
                                        },
                                    ],

                                    'ingresos'
                                ),
                            },
                            {
                                name: 'descripcion_otros_ingresos',
                                label: 'Descripción otros ingresos',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .DESCRIPTION_ACTIVITY.maxLength,
                                        },
                                    ],

                                    'descripción actividad económica'
                                ),
                            },
                            {
                                name: 'negocio_actividad',
                                label: 'Actividad económica',
                                disabled: false,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                            },
                            {
                                name: 'trabajo_ciudad',
                                label: 'Ciudad del trabajo',
                                disabled: false,
                                type: 'autocomplete-dependency',
                                showTable: true,
                                parentDependency: true,
                                childrenDependency: 'trabajo_barrio',
                                col: 6,
                                options: [],
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'trabajo_barrio',
                                label: 'Barrio del trabajo',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                dependency: 'trabajo_ciudad',
                                trueDependency: 'ciudad',
                                url: URL.BARRIOS.value,
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección del trabajo',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'trabajo_referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],

                                    'referencia ubicación'
                                ),
                            },
                        ],
                    },
                ],

                defaultValues: {
                    tipo_de_documento: 'CC',
                    numero_identificacion: '123455556',
                    primer_nombre: 'test 1',
                    segundo_nombre: 'test 2',
                    primer_apellido: 'test ape1',
                    segundo_apellido: 'test ape2',
                    genero: 'H',
                    lugar_expedicion_documento: 1205,
                    fecha_expedicion_documento: '2020-08-30',
                    lugar_nacimiento: 1205,
                    fecha_nacimiento: '2020-08-30',
                    telefono_celular: '3105436525',
                    telefono_fijo: '5555555',

                    //info-trabajo
                    empresa: 'pruebas',
                    direccion_trabajo: 'vereda  aaaa',
                    codigo_postal: '76001',
                    descripcion_actividad_economica: 'test information',
                    antiguedad: 1,
                    telefono_empresa: '3215647',
                    ingresos: '200000',
                    actividad_economica: 'Venta de jugos',
                },
            },
            codebtorCredit: {
                permission: [
                    'codebtorCredit:list',
                    'codebtorCredit:edit',
                    'codebtorCredit:delete',
                ],

                fields: [],
            },
            codebtorInformation: {
                tittle: 'codeudor',
                fields: [
                    {
                        name: 'tipo_relacion',
                        label: 'Tipo relación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_persona,
                        validation: validationDefault(
                            ['required'],
                            'tipo relación'
                        ),
                        testid: 'CodebtorRelationshipInput',
                    },
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                        testid: 'CodebtorTypeIdInput',
                    },

                    {
                        name: 'numero_identificacion',
                        label: 'Número identificación',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],

                            'número de identificación'
                        ),
                        testid: 'CodebtorIdInput',
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],

                            'primer nombre'
                        ),
                        testid: 'CodebtorFirstNameInput',
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo nombre'
                        ),
                        testid: 'CodebtorSecondNameInput',
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],

                            'primer apellido'
                        ),
                        testid: 'CodebtorLastFirsNameInput',
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo apellido'
                        ),
                        testid: 'ClientSecondFirsNameInput',
                    },
                    {
                        name: 'genero',
                        label: 'Género',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                        validation: validationDefault(['required'], 'genero'),
                        testid: 'CodebtorGenderInput',
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        label: 'Lugar expedición documento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de expedición documento'
                        ),
                        testid: 'CodebtorDocumentPlaceInput',
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        label: 'Fecha expedición documento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de expedición del documento'
                        ),
                        testid: 'CodebtorDocumentDateInput',
                    },
                    {
                        name: 'lugar_nacimiento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de nacimiento'
                        ),
                        testid: 'CodebtorBirthPlaceInput',
                    },
                    {
                        name: 'fecha_nacimiento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                        testid: 'CodebtorBirthDateInput',
                    },
                    // {
                    //     name: 'tipo_relacion',
                    //     label: 'Tipo relación',
                    //     disabled: true,
                    //     type: 'hidden',
                    //     col: 3,
                    //     value: 1,
                    // },
                ],
                socioEconomicCodebtor: {
                    fields: [
                        {
                            name: 'naturaleza_persona',
                            label: 'Tipo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_codeudor,
                            validation: validationDefault(
                                ['required'],
                                'naturaleza'
                            ),
                            isMulti: false,
                            testid: 'CodebtorTypeInput',
                        },
                    ],

                    fieldsConditional: {
                        pI: [
                            {
                                name: 'estado_civil',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                                testid: 'CodebtorCivilStatusInput',
                            },
                            {
                                name: 'tipo_vivienda',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_vivienda,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'tipo vivienda'
                                ),
                                testid: 'CodebtorHousingTypeInput',
                            },
                            {
                                name: 'estrato',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.STRATUM.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.STRATUM.min,
                                        },
                                    ],

                                    'estrato'
                                ),
                                testid: 'CodebtorStratumInput',
                            },
                            {
                                name: 'personas_a_cargo',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .min,
                                        },
                                    ],

                                    'personas a cargo'
                                ),
                                testid: 'CodebtorPeopleChargeInput',
                            },
                            {
                                name: 'numero_hijos',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .min,
                                        },
                                    ],

                                    'número de hijos'
                                ),
                                testid: 'CodebtorChildrenNumberInput',
                            },
                            {
                                name: 'escolaridad',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                validation: validationDefault(
                                    ['required'],
                                    'escolaridad'
                                ),
                                testid: 'CodebtorSchoolingInput',
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Nombre del negocio',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],

                                    'nombre del negocio'
                                ),
                                testid: 'CodebtorBusinessNameInput',
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono del negocio',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono del negocio'
                                ),
                                testid: 'CodebtorBusinessPhoneInput',
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],

                                    'celular'
                                ),
                                testid: 'CodebtorBusinessCellphoneInput',
                            },
                            {
                                name: 'negocio_liquidez',
                                label: 'Liquidez',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'liquidez'
                                ),
                                testid: 'CodebtorLiquidityInput',
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad  (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],

                                    'antigüedad residencia'
                                ),
                                testid: 'CodebtorAntiquityInput',
                            },
                            {
                                name: 'negocio_actividad',
                                label: 'Actividad económica',
                                disabled: false,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                                validation: validationDefault(
                                    ['required'],
                                    'Actividad económica'
                                ),
                                testid: 'CodebtorActivityInput',
                            },
                            {
                                name: 'negocio_descripcion',
                                label: 'Descripción actividad económica',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES
                                                .DESCRIPTION_ACTIVITY.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .DESCRIPTION_ACTIVITY.maxLength,
                                        },
                                    ],

                                    'descripción actividad económica'
                                ),
                                testid: 'CodebtorActivityDescriptionInput',
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección del negocio',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección del negocio'
                                ),
                                testid: 'CodebtorBusinessAddressInput',
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],

                                    'referencia ubicación'
                                ),
                                testid: 'CodebtorLocationReferenceInput',
                            },
                        ],

                        pE: [
                            // EMPLEADO
                            {
                                name: 'estado_civil',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                                testid: 'CodebtorCivilStatusInput',
                            },
                            {
                                name: 'tipo_vivienda',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_vivienda,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'tipo vivienda'
                                ),
                                testid: 'CodebtorHousingTypeInput',
                            },
                            {
                                name: 'estrato',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.STRATUM.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.STRATUM.min,
                                        },
                                    ],

                                    'estrato'
                                ),
                                testid: 'CodebtorStratumInput',
                            },
                            {
                                name: 'personas_a_cargo',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .min,
                                        },
                                    ],

                                    'personas a cargo'
                                ),
                                testid: 'CodebtorPeopleInChargeInput',
                            },
                            {
                                name: 'numero_hijos',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .min,
                                        },
                                    ],

                                    'número de hijos'
                                ),
                                testid: 'CodebtorChildrenNumberInput',
                            },
                            {
                                name: 'escolaridad',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                validation: validationDefault(
                                    ['required'],
                                    'escolaridad'
                                ),
                                testid: 'CodebtorEducationInput',
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],

                                    'empresa'
                                ),
                                testid: 'CodebtorJobNameInput',
                            },
                            {
                                name: 'empresa_contrato',
                                label: 'Contrato',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                                validation: validationDefault(
                                    ['required'],
                                    'contrato'
                                ),
                                testid: 'CodebtorJobContractInput',
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Cargo',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],

                                    'cargo'
                                ),
                                testid: 'CodebtorJobPositionInput',
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'salario'
                                ),
                                testid: 'CodebtorJobSalaryInput',
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad empresa (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],

                                    'antigüedad empresa'
                                ),
                                testid: 'CodebtorJobAntiquityInput',
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección empresa',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección empresa'
                                ),
                                testid: 'CodebtorJobAddressInput',
                            },

                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],

                                    'referencia ubicación'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono empresa',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],

                                    'celular'
                                ),
                            },
                        ],

                        pP: [
                            // PENSIONADO
                            {
                                name: 'estado_civil',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                                testid: 'CodebtorCivilStatusInput',
                            },
                            {
                                name: 'tipo_vivienda',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_vivienda,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'tipo vivienda'
                                ),
                                testid: 'CodebtorHouseTypeInput',
                            },
                            {
                                name: 'estrato',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.STRATUM.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.STRATUM.min,
                                        },
                                    ],

                                    'estrato'
                                ),
                                testid: 'CodebtorEstratumInput',
                            },
                            {
                                name: 'personas_a_cargo',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .min,
                                        },
                                    ],

                                    'personas a cargo'
                                ),
                                testid: 'CodebtorPeopleInChargeInput',
                            },
                            {
                                name: 'numero_hijos',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .min,
                                        },
                                    ],

                                    'número de hijos'
                                ),
                                testid: 'CodebtorNumberOfChildrenInput',
                            },
                            {
                                name: 'escolaridad',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                validation: validationDefault(
                                    ['required'],
                                    'escolaridad'
                                ),
                                testid: 'CodebtorSchoolingInput',
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],

                                    'empresa'
                                ),
                                testid: 'ConyugeJobNameInput',
                            },
                            {
                                name: 'empresa_contrato',
                                label: 'Contrato',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                                validation: validationDefault(
                                    ['required'],
                                    'contrato'
                                ),
                                testid: 'CodebtorJobContractInput',
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Cargo',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],

                                    'cargo'
                                ),
                                testid: 'ConyugeJobPositionInput',
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'salario'
                                ),
                                testid: 'CodebtorJobSalaryInput',
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad empresa (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],

                                    'antigüedad empresa'
                                ),
                                testid: 'CodebtorJobAntiquityInput',
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección empresa',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección empresa'
                                ),
                                testid: 'CodebtorJobAddressInput',
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],

                                    'referencia ubicación'
                                ),
                                testid: 'CodebtorJobLocationReferenceInput',
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono empresa',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono de la empresa'
                                ),
                                testid: 'CodebtorJobPhoneInput',
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],

                                    'celular'
                                ),
                                testid: 'CodebtorJobCellphoneInput',
                            },
                        ],

                        pFR: [
                            // FINCA RAIZ
                            {
                                name: 'estado_civil',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                                testid: 'CodebtorCivilStatusInput',
                            },
                            {
                                name: 'tipo_vivienda',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_vivienda,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'tipo vivienda'
                                ),
                                testid: 'CodebtorHousingTypeInput',
                            },
                            {
                                name: 'estrato',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.STRATUM.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.STRATUM.min,
                                        },
                                    ],

                                    'estrato'
                                ),
                                testid: 'CodebtorStratumInput',
                            },
                            {
                                name: 'personas_a_cargo',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .min,
                                        },
                                    ],

                                    'personas a cargo'
                                ),
                                testid: 'CodebtorPeopleChargeInput',
                            },
                            {
                                name: 'numero_hijos',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .min,
                                        },
                                    ],

                                    'número de hijos'
                                ),
                                testid: 'CodebtorChildrenNumberInput',
                            },
                            {
                                name: 'escolaridad',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                validation: validationDefault(
                                    ['required'],
                                    'escolaridad'
                                ),
                                testid: 'CodebtorSchoolingInput',
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],

                                    'empresa'
                                ),
                                testid: 'CodebtorJobNameInput',
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Ocupación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],

                                    'Ocupación'
                                ),
                                testid: 'CodebtorJobPositionInput',
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                testid: 'CodebtorJobSalaryInput',
                            },
                        ],

                        pFS: [
                            // FIRMA SOLIDARIA
                            {
                                name: 'estado_civil',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                testid: 'CodebtorCivilStatusInput',
                            },
                            {
                                name: 'tipo_vivienda',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_vivienda,
                                testid: 'CodebtorHousingTypeInput',
                            },
                            {
                                name: 'estrato',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                testid: 'CodebtorStratumInput',
                            },
                            {
                                name: 'personas_a_cargo',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                testid: 'CodebtorPeopleChargeInput',
                            },
                            {
                                name: 'numero_hijos',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                testid: 'CodebtorChildrenNumberInput',
                            },
                            {
                                name: 'escolaridad',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                testid: 'CodebtorSchoolingInput',
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],

                                    'empresa'
                                ),
                                testid: 'CodebtorJobNameInput',
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Ocupación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                                testid: 'CodebtorJobPositionInput',
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                testid: 'CodebtorJobSalaryInput',
                            },
                        ],
                    },
                },
                contactCodebtor: {
                    fields: [
                        {
                            name: 'ciudad_contacto',
                            label: 'Ciudad',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 6,
                            showTable: true,
                            options: [],
                            parentDependency: true,
                            childrenDependency: 'barrio_contacto',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad de contacto'
                            ),
                            testid: 'CodebtorCityInput',
                        },
                        {
                            name: 'barrio_contacto',
                            disabled: false,
                            type: 'select',
                            col: 6,
                            showTable: true,
                            dependency: 'ciudad_contacto',
                            options: [],
                            url: URL.BARRIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'barrio de contacto'
                            ),
                            testid: 'CodebtorNeighborhoodInput',
                        },
                        {
                            name: 'direccion',
                            label: 'Dirección',
                            disabled: false,
                            type: 'addressComplement',
                            staticCol: 12,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'required',
                                        value: PROPERTIES.ADDRESS.required,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.ADDRESS.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.ADDRESS.minLength,
                                    },
                                ],

                                'dirección'
                            ),
                            testid: 'CodebtorInformationAddressInput',
                        },
                        {
                            name: 'referencia_ubicacion',
                            label: 'Referencia ubicación',
                            disabled: false,
                            type: 'string',
                            col: 6,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES
                                            .BUSINESS_LOCATION_REFERENCE
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES
                                            .BUSINESS_LOCATION_REFERENCE
                                            .maxLength,
                                    },
                                ],

                                'referencia ubicación'
                            ),
                            testid: 'CodebtorLocationReferenceInput',
                        },
                        {
                            name: 'telefono',
                            label: 'Teléfono',
                            disabled: false,
                            type: 'phone',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                ],

                                'teléfono'
                            ),
                            testid: 'CodebtorInformationPhoneInput',
                        },
                        {
                            name: 'celular',
                            label: 'Celular',
                            disabled: false,
                            type: 'celular',
                            col: 3,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.CELL_PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                    {
                                        type: 'required',
                                        value: PROPERTIES.CELL_PHONE.required,
                                    },
                                ],

                                'celular'
                            ),
                            testid: 'CodebtorInformationCellphoneInput',
                        },
                        {
                            name: 'correo_electronico',
                            label: 'Correo electrónico',
                            disabled: false,
                            type: 'email',
                            col: 6,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.EMAIL.regExp,
                                        mesagge:
                                            'El correo electrónico ingresado no es válido',
                                    },
                                    {
                                        type: 'required',
                                        value: PROPERTIES.EMAIL.required,
                                    },
                                ],

                                'correo electrónico'
                            ),
                            testid: 'CodebtorInformationEmailInput',
                        },
                        {
                            name: 'principal',
                            label: 'Principal',
                            disabled: false,
                            type: 'select',
                            options: genericOptions.direccion_principal,
                            defaultValue: [],
                            col: 6,
                            showTable: true,
                            testid: 'CodebtorInformationPrincipalInput',
                        },
                    ],
                },
                codebtorConyuge: {
                    fields: [
                        {
                            name: 'Información básica',
                            desc: '',
                            fields: [
                                {
                                    name: 'tipo_identificacion',
                                    label: 'Tipo identificación',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.tipo_de_documento,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo identificación'
                                    ),
                                    testid: 'CodebtorConyugeTypeIdInput',
                                },
                                {
                                    name: 'numero_identificacion',
                                    label: 'Número identificación',
                                    disabled: false,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ID_NUMBER
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ID_NUMBER
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ID_NUMBER
                                                    .minLength,
                                            },
                                        ],

                                        'número de identificación'
                                    ),
                                    testid: 'CodebtorConyugeIdInput',
                                },
                                {
                                    name: 'primer_nombre',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.FIRST_NAME
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.FIRST_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.FIRST_NAME
                                                    .minLength,
                                            },
                                        ],

                                        'primer nombre'
                                    ),
                                    testid: 'CodebtorConyugeFirstNameInput',
                                },
                                {
                                    name: 'segundo_nombre',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .minLength,
                                            },
                                        ],

                                        'segundo nombre'
                                    ),
                                    testid: 'CodebtorConyugeSecondNameInput',
                                },
                                {
                                    name: 'primer_apellido',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .minLength,
                                            },
                                        ],

                                        'primer apellido'
                                    ),
                                    testid: 'CodebtorConyugeFirstSurnameInput',
                                },
                                {
                                    name: 'segundo_apellido',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.SECOND_SURNAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .minLength,
                                            },
                                        ],

                                        'segundo nombre'
                                    ),
                                    testid: 'CodebtorConyugeSecondSurnameInput',
                                },
                                {
                                    name: 'genero',
                                    label: 'Género',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.genero,
                                    validation: validationDefault(
                                        ['required'],
                                        'genero'
                                    ),
                                    testid: 'CodebtorConyugeGenderInput',
                                },
                                {
                                    name: 'lugar_nacimiento',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 3,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'lugar de nacimiento'
                                    ),
                                    testid: 'CodebtorConyugeBirthPlaceInput',
                                },
                                {
                                    name: 'fecha_nacimiento',
                                    disabled: false,
                                    type: 'date',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'fecha de nacimiento'
                                    ),
                                    testid: 'CodebtorConyugeBirthDateInput',
                                },
                                {
                                    name: 'tipo_relacion',
                                    label: 'Tipo relación',
                                    disabled: false,
                                    type: 'hidden',
                                    col: 3,
                                    value: 2,
                                    testid: 'CodebtorRelationshipInput',
                                },
                            ],

                            defaultValues: {
                                tipo_de_documento: 'CC',
                                numero_identificacion: Math.floor(
                                    randomFloat(0, 1) * 10000
                                ),
                                primer_nombre: 'test 1',
                                segundo_nombre: 'test 2',
                                primer_apellido: 'test ape1',
                                segundo_apellido: 'test ape2',
                                genero: 'H',
                                lugar_expedicion_documento: 1205,
                                fecha_expedicion_documento: '2020-08-30',
                                lugar_nacimiento: 1205,
                                fecha_nacimiento: '2020-08-30',
                                telefono: '3102344556',
                                //info-trabajo
                                estado_civil: 'S',
                                estrato: 1,
                                ciuu: 10,
                                descripcion_actividad_economica:
                                    'test information',
                                antiguedad_residencia: 1,
                                personas_a_cargo: 1,
                                numero_hijos: 1,
                                escolaridad: 'PO',
                                naturaleza: 'I',
                            },
                        },
                        {
                            name: 'Información de contacto',
                            desc: '',
                            fields: [
                                {
                                    name: 'ciudad_contacto',
                                    label: 'Ciudad',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 6,
                                    showTable: true,
                                    options: [],
                                    parentDependency: true,
                                    childrenDependency: 'barrio_contacto',
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad de contacto'
                                    ),
                                    testid: 'CodebtorConyugeCityInput',
                                },
                                {
                                    name: 'barrio_contacto',
                                    disabled: false,
                                    type: 'select',
                                    col: 6,
                                    showTable: true,
                                    dependency: 'ciudad_contacto',
                                    options: [],
                                    url: URL.BARRIOS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'barrio de contacto'
                                    ),
                                    testid: 'CodebtorConyugeNeighborhoodInput',
                                },
                                {
                                    name: 'direccion',
                                    label: 'Dirección',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ADDRESS
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ADDRESS
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ADDRESS
                                                    .minLength,
                                            },
                                        ],

                                        'dirección'
                                    ),
                                    testid: 'CodebtorConyugeAddressInput',
                                },
                                {
                                    name: 'referencia_ubicacion',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                    showTable: true,
                                    testid: 'CodebtorConyugeUbicationInput',
                                },
                                {
                                    name: 'telefono',
                                    label: 'Teléfono',
                                    disabled: false,
                                    type: 'phone',
                                    col: 6,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],

                                        'teléfono'
                                    ),
                                    testid: 'CodebtorConyugePhoneInput',
                                },
                                {
                                    name: 'celular',
                                    label: 'Celular',
                                    disabled: false,
                                    type: 'celular',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.CELL_PHONE
                                                    .regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.CELL_PHONE
                                                    .required,
                                            },
                                        ],

                                        'celular'
                                    ),
                                    testid: 'CodebtorConyugeCellphoneInput',
                                },
                                {
                                    name: 'correo_electronico',
                                    label: 'Correo electrónico',
                                    disabled: false,
                                    type: 'email',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.EMAIL.regExp,
                                                mesagge:
                                                    'El correo electrónico ingresado no es válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.EMAIL
                                                    .required,
                                            },
                                        ],

                                        'correo electrónico'
                                    ),
                                    testid: 'CodebtorConyugeEmailInput',
                                },
                            ],
                        },
                        {
                            name: 'Información del trabajo',
                            desc: '',
                            fields: [
                                {
                                    name: 'trabajo_nombre',
                                    label: 'Empresa',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.JOB_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.JOB_NAME
                                                    .minLength,
                                            },
                                        ],

                                        'empresa'
                                    ),
                                    testid: 'CodebtorConyugeJobNameInput',
                                },
                                {
                                    name: 'trabajo_antiguedad',
                                    label: 'Antigüedad (meses)',
                                    disabled: false,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'max',
                                                value: PROPERTIES.ANTIQUITY.max,
                                            },
                                            {
                                                type: 'min',
                                                value: PROPERTIES.ANTIQUITY.min,
                                            },
                                        ],

                                        'antigüedad (meses)'
                                    ),
                                    testid: 'CodebtorConyugeJobAntiquityInput',
                                },
                                {
                                    name: 'trabajo_telefono',
                                    label: 'Teléfono de la empresa',
                                    disabled: false,
                                    type: 'phone',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],

                                        'teléfono de la empresa'
                                    ),
                                    testid: 'ConyugeJobPhoneInput',
                                },
                                {
                                    name: 'empresa_salario',
                                    label: 'Ingresos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.INCOME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.INCOME
                                                    .minLength,
                                            },
                                        ],

                                        'ingresos'
                                    ),
                                    testid: 'CodebtorConyugeCompanySalaryInput',
                                },
                                {
                                    name: 'otros_ingresos',
                                    label: 'Otros ingresos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.INCOME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.INCOME
                                                    .minLength,
                                            },
                                        ],

                                        'Otros ingresos'
                                    ),
                                    testid: 'CodebtorConyugeOtherIncomeInput',
                                },
                                {
                                    name: 'descripcion_otros_ingresos',
                                    label: 'Descripción otros ingresos',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES
                                                    .DESCRIPTION_ACTIVITY
                                                    .maxLength,
                                            },
                                        ],

                                        'descripción actividad económica'
                                    ),
                                    testid: 'CodebtorConyugeOtherIncomeDescriptionInput',
                                },
                                {
                                    name: 'negocio_actividad',
                                    label: 'Actividad económica',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 6,
                                    options: [],
                                    url: URL.ACTIVIDAD_ECONOMICA.value,
                                    testid: 'CodebtorConyugeActivityInput',
                                },
                                {
                                    name: 'trabajo_ciudad',
                                    label: 'Ciudad de trabajo',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    parentDependency: true,
                                    childrenDependency: 'trabajo_barrio',
                                    col: 6,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                    testid: 'CodebtorConyugeJobCityInput',
                                },
                                {
                                    name: 'trabajo_barrio',
                                    label: 'Barrio del trabajo',
                                    disabled: false,
                                    type: 'select',
                                    col: 6,
                                    dependency: 'trabajo_ciudad',
                                    trueDependency: 'ciudad',
                                    url: URL.BARRIOS.value,
                                    testid: 'CodebtorConyugeJobNeighborhoodInput',
                                },
                                {
                                    name: 'trabajo_direccion',
                                    label: 'Dirección del trabajo',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                    testid: 'CodebtorConyugeJobAddressInput',
                                },
                                {
                                    name: 'trabajo_referencia_ubicacion',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES
                                                    .BUSINESS_LOCATION_REFERENCE
                                                    .minLength,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES
                                                    .BUSINESS_LOCATION_REFERENCE
                                                    .maxLength,
                                            },
                                        ],

                                        'referencia ubicación'
                                    ),
                                    testid: 'CodebtorConyugeJobReferenceInput',
                                },
                            ],
                        },
                    ],
                },
            },
            heritageCodebtor: {
                fields: [
                    {
                        name: 'Presupuesto familiar',
                        testid: 'HeritageCodebtorFamilyBudgetInput',
                        desc: '...',
                        fields: [
                            {
                                name: 'ingreso_principal',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'ingreso principal'
                                ),
                                testid: 'CodebtorHeritagePrincipalIncomeInput',
                            },
                            {
                                name: 'ingreso_conyuge',
                                label: 'Ingresos cónyuge',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'Ingresos conyuge'
                                ),
                                testid: 'CodebtorHeritageConyugeIncomeInput',
                            },
                            {
                                name: 'otros_ingresos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'otros ingresos'
                                ),
                                testid: 'CodebtorHeritageOtherIncomeInput',
                            },
                            {
                                name: 'gastos_familiar',
                                label: 'Gasto familiar',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'gasto familiar'
                                ),
                                testid: 'CodebtorHeritageFamilyExpensesInput',
                            },
                            {
                                name: 'obligaciones',
                                label: 'Obligaciones / cuotas',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'obligaciones / cuotas'
                                ),
                                testid: 'CodebtorHeritageObligationsInput',
                            },
                            {
                                name: 'excedente',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'excedente'
                                ),
                                testid: 'CodebtorHeritageSurplusInput',
                            },
                        ],
                    },
                    {
                        name: 'Presupuesto empresarial',
                        testid: 'HeritageCodebtorBusinessBudgetInput',
                        desc: '...',
                        fields: [
                            {
                                name: 'total_activos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total activos'
                                ),
                                testid: 'CodebtorHeritageAssetsInput',
                            },
                            {
                                name: 'total_pasivos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total pasivo'
                                ),
                                testid: 'CodebtorHeritageLiabilitiesInput',
                            },
                            {
                                name: 'total_patrimonio',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total patrimonio'
                                ),
                                testid: 'CodebtorHeritageEquityInput',
                            },
                        ],
                    },
                ],

                realState: [
                    {
                        name: 'Bienes raices',
                        testid: 'HeritageCodebtorRealEstateInput',
                        desc: '...',
                        fields: [
                            {
                                name: 'tipo_vivienda',
                                label: 'Tipo de bien raíz',
                                disabled: false,
                                type: 'select',
                                options: genericOptions.tipo_de_bien_raiz,
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'tipo de bien raíz'
                                ),
                                testid: 'HeritageCodebtorHousingTypeInput',
                            },
                            {
                                name: 'valor_bien_raiz',
                                label: 'Valor comercial',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'valor comercial'
                                ),
                                testid: 'HeritageCodebtorRealEstateValueInput',
                            },
                            {
                                name: 'direccion_bien_raiz',
                                label: 'Dirección',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ADDRESS.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.ADDRESS.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.ADDRESS.minLength,
                                        },
                                    ],

                                    'dirección'
                                ),
                                testid: 'HeritageCodebtorRealEstateAddressInput',
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],

                                    'referencia ubicación'
                                ),
                                testid: 'HeritageCodebtorRealEstateReferenceInput',
                            },
                        ],
                    },
                ],

                ownVehicle: [
                    {
                        name: 'Vehículo',
                        testid: 'HeritageCodebtorVehicleInput',
                        desc: '...',
                        fields: [
                            {
                                name: 'marca',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                url: URL.MARCAS.value,
                                validation: validationDefault(
                                    ['required'],
                                    'marca'
                                ),
                                testid: 'HeritageCodebtorBrandInput',
                            },
                            {
                                name: 'placa',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.VEHICLE_PLATE
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.VEHICLE_PLATE
                                                .minLength,
                                        },
                                        {
                                            type: 'pattern',
                                            value: /^[a-zA-Z0-9_.-]*$/,
                                            mesagge:
                                                'La placa solo debe tener numeros y letras',
                                        },
                                    ],

                                    'placa'
                                ),
                                testid: 'HeritageCodebtorPlateInput',
                            },
                            {
                                name: 'modelo',
                                disabled: false,
                                type: 'integer',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.VEHICLE_MODEL
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.VEHICLE_MODEL
                                                .minLength,
                                        },
                                    ],

                                    'modelo'
                                ),
                                testid: 'HeritageCodebtorModelInput',
                            },
                            {
                                name: 'valor_vehiculo',
                                label: 'Valor comercial',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'valor comercial'
                                ),
                                testid: 'HeritageCodebtorVehicleValueInput',
                            },
                        ],
                    },
                ],
            },
            reportTeamPerformance: {
                fields: [
                    {
                        name: 'groups',
                        label: 'Rol',
                        disabled: false,
                        type: 'hidden',
                        col: 4,
                        defaultValue: { value: 4, label: 'MESA DE APROBACION' },
                    },
                    {
                        name: 'user',
                        label: 'Usuario',
                        disabled: false,
                        type: 'hidden',
                        col: 4,
                    },
                    {
                        name: 'type_group',
                        label: 'Tipo',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [
                            { value: 0, label: 'AÑO - MES' },
                            { value: 1, label: 'MES - DIA' },
                        ],

                        defaultValue: { value: 0, label: 'AÑO - MES' },
                    },
                    {
                        name: 'year',
                        label: 'Año',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.anios_report,
                        defaultValue: defaultYearReport(),
                    },
                    {
                        name: 'month',
                        label: 'Mes',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_report,
                    },
                ],
            },
            reportsGeneral: {
                fields: [
                    {
                        name: 'tipo_reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: '/globals/gestor_reportes/?rol=4',
                        validation: {
                            required: {
                                value: true,
                                message: 'El tipo reporte es obligatorio',
                            },
                        },
                        notSearchGlobals: true,
                    },
                    {
                        name: 'fecha_desde',
                        label: 'Fecha desde',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha desde es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'fecha_hasta',
                        label: 'Fecha hasta',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha hasta es obligatoria',
                            },
                        },
                    },
                ],
            },
            AnalisisMicroOne: {
                permisions: ['AnalisisMicroOne:onlyRead'],
                fields: [
                    {
                        estabilidad: [
                            {
                                name: 'casado_con_hijos',
                                label: 'CASADO CON HIJOS',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'propietario_de_casas',
                                label: 'PROPIETARIO DE CASA',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'mas_dos_anos_en_vivienda',
                                label: '+2 AÑOS EN LA VIVIENDA',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'mas_dos_anos_como_propietario_neg',
                                label: '+2 AÑOS COMO PROPIETARIO DEL NEGOCIO',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'mas_dos_anos_con_negocio_mismo_l',
                                label: '+2 AÑOS CON EL NEGOCIO EN MISMO LUGAR',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                        ],

                        responsabilidadPago: [
                            {
                                name: 'pago_credito_a_tiempo',
                                label: 'PAGO DE CRÉDITO A TIEMPO',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'pago_servicios_publicos_sin_mora',
                                label: 'PAGO SERVICIOS PÚBLICOS SIN MORA',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'creditos_con_proveedores',
                                label: 'TIENE CRÉDITO CON PROVEEDORES',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                        ],

                        reputacion: [
                            {
                                name: 'recomendado_por_buen_cliente',
                                label: 'RECOMENDADO POR BUEN CLIENTE',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'buena_reputacion_de_vecinos',
                                label: 'BUENA REPUTACIÓN DE VECINOS',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'buena_reputacion_proveedores',
                                label: 'BUENA REPUTACIÓN PROVEEDORES',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'buena_reputacion_arrendadores',
                                label: 'BUENA REPUTACIÓN ARRENDADORES',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                        ],

                        habilidad: [
                            {
                                name: 'libro_de_compras_y_ventas',
                                label: 'LIBRO DE COMPRAS Y VENTAS',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'negocio_en_area_comercial',
                                label: 'NEGOCIO EN ÁREA COMERCIALS',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'crecimiento_del_negocio',
                                label: 'CRECIMIENTO DEL NEGOCIO',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'ingresos_adicionales',
                                label: 'INGRESOS ADICIONALES',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                            {
                                name: 'numero_de_empleados',
                                label: 'N° DE EMPLEADOS',
                                disabled: true,
                                type: 'checkbox',
                                col: 3,
                                typeColumn: 3,
                            },
                        ],

                        ambienteFamiliar: [
                            {
                                name: 'ambiente_familiar',
                                label: 'Ambiente Familiar',
                                disabled: true,
                                type: 'slide',
                                col: 12,
                                typeColumn: 2,
                                rangoMin: 0,
                                rangoMax: 5,
                                validation: validationDefault(
                                    ['required'],
                                    'Ambiente Familiar'
                                ),
                            },
                        ],
                    },
                ],
            },
            AnalisisMicroTwo: {
                permisions: ['AnalisisMicroTwo:onlyRead'],
                fields: [
                    {
                        name: 'dias_buenos',
                        label: 'Dias Buenos',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        placeholder: '# 1-7 ',
                        validation: validationDefault(
                            ['required'],
                            'Dias Buenos'
                        ),
                    },
                    {
                        name: 'ventas_dias_buenos',
                        label: 'Ventas Buenas',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'Dias Buenos'
                        ),
                    },
                    {
                        name: 'dias_regulares',
                        label: 'Dias Regulares',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        placeholder: '# 1-7 ',
                        validation: validationDefault(
                            ['required'],
                            'Dias Buenos'
                        ),
                    },
                    {
                        name: 'ventas_dias_regulares',
                        label: 'Ventas Regulares',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'Dias Buenos'
                        ),
                    },
                    {
                        name: 'dias_malos',
                        label: 'Dias Malos',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        placeholder: '# 1-7 ',
                        validation: validationDefault(
                            ['required'],
                            'Dias Buenos'
                        ),
                    },
                    {
                        name: 'ventas_dias_malos',
                        label: 'Ventas Malas',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'Dias Buenos'
                        ),
                    },
                    {
                        name: 'ventas_semanales',
                        label: 'Total Ventas Semanales',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        placeholder: '# Ventas Semanales',
                    },
                    {
                        name: 'ventas_mensuales',
                        label: 'Total Ventas mensuales',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        placeholder: '# Ventas Mensuales',
                    },
                ],
            },
            AnalisisMicroThree: {
                permisions: ['AnalisisMicroThree:onlyRead'],
                fields: [
                    {
                        name: 'lunes',
                        label: 'Lunes',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Lunes'),
                    },
                    {
                        name: 'martes',
                        label: 'Martes',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Martes'),
                    },
                    {
                        name: 'miercoles',
                        label: 'Miercoles',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'Miercoles'
                        ),
                    },
                    {
                        name: 'jueves',
                        label: 'Jueves',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Jueves'),
                    },
                    {
                        name: 'viernes',
                        label: 'Viernes',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Viernes'),
                    },
                    {
                        name: 'sabado',
                        label: 'Sabados',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Sabados'),
                    },
                    {
                        name: 'domingo',
                        label: 'Domingo',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Domingo'),
                    },
                    {
                        name: 'dias',
                        label: 'Dias',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefault(['required'], 'Dias'),
                    },
                    {
                        name: 'total_mes',
                        label: 'Total',
                        disabled: true,
                        type: 'price',
                        col: 3,
                    },
                    {
                        name: 'promedio',
                        label: 'Promedio',
                        disabled: true,
                        type: 'percentage',
                        col: 3,
                    },
                ],
            },
            AnalisisMicroSix: {
                permisions: ['AnalisisMicroSix:onlyRead'],
                fields: [
                    {
                        name: 'semana1',
                        label: 'Semana 1',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Semana 1'),
                    },
                    {
                        name: 'semana2',
                        label: 'Semana 2',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Semana 2'),
                    },
                    {
                        name: 'semana3',
                        label: 'Semana 3',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Semana 3'),
                    },
                    {
                        name: 'semana4',
                        label: 'Semana 4',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefault(['required'], 'Semana 4'),
                    },
                    {
                        name: 'total_mes',
                        label: 'Total',
                        disabled: true,
                        type: 'price',
                        col: 3,
                    },
                ],
            },
        },
    },
};

export default Rules;
